import './loading.css';
import Vue from 'vue';

export const name = "loading";//必须定义一个name的常量，配合自动注册逻辑使用
export default {
  bind (el, binding) {

    Vue.nextTick(() => {

      let _computedStyle = window.getComputedStyle(el);
      let _position = _computedStyle.getPropertyValue('position');
      if (_position == 'static') {
        el.style.position = 'relative';
      }

      /**
       * 元素属性配置：
       * 1、mask-bgcolor：遮罩层颜色，默认为 #f3f4f6（.loading-square-jelly-mask）
       * ----------------------------------------------------------
       * 2、loading-text：提示文字，如不设置则不展示提示文字信息
       * 3、text-color：提示文字颜色，默认为 #999999（.loading-square-jelly-mask .loading-text）
       * 4、
       * ----------------------------------------------------------
       * 5、
       * 5、square-color：加载方块颜色，默认为 #abc0e7（.loading-square-jelly-mask .loading-square-jelly-box）
       * 6、
       * 7、square-shadow-color：加载方块阴影颜色，默认为 #3b73d7（.loading-square-jelly-mask .loading-square-jelly-box > div:nth-child(2)）
       * 8、square-shadow-opacity：加载方块阴影透明度，默认为 0.15（.loading-square-jelly-mask .loading-square-jelly-box > div:nth-child(2)）
       */

      //
      let _mask_bgcolor = el.getAttribute('mask-bgcolor');
      //

      let _square_color = el.getAttribute('square-color');
      let _square_shadow_color = el.getAttribute('square-shadow-color');
      let _square_shadow_opacity = el.getAttribute('square-shadow-opacity');
      //
      let _loading_text = el.getAttribute('loading-text');
      let _text_color = el.getAttribute('text-color');

      const __el_mask__ = document.createElement('div');
      __el_mask__.className = 'loading-square-jelly-mask';
      __el_mask__.style.display = 'none';
      if (_mask_bgcolor) {
        __el_mask__.style.backgroundColor = _mask_bgcolor;
      }

      const __el_square_jelly_box__ = document.createElement('div');
      __el_square_jelly_box__.className = 'loading-square-jelly-box running';//running paused
      if (_square_color) {
        __el_square_jelly_box__.style.color = _square_color;
      }


      const __el_square_jelly_box_child_1__ = document.createElement('div');
      const __el_square_jelly_box_child_2__ = document.createElement('div');
      if (_square_shadow_color) {
        __el_square_jelly_box_child_2__.style.background = _square_shadow_color;
      }
      if (_square_shadow_opacity == 0 || _square_shadow_opacity == "0" || _square_shadow_opacity) {
        __el_square_jelly_box_child_2__.style.opacity = _square_shadow_opacity;
      }

      __el_square_jelly_box__.appendChild(__el_square_jelly_box_child_1__);
      __el_square_jelly_box__.appendChild(__el_square_jelly_box_child_2__);

      __el_mask__.appendChild(__el_square_jelly_box__);

      if (_loading_text) {
        const __el_loading_text__ = document.createElement('div');
        __el_loading_text__.className = 'loading-text';
        __el_loading_text__.innerText = _loading_text || '';
        if (_text_color) {
          __el_loading_text__.style.color = _text_color;
        }

        __el_mask__.appendChild(__el_loading_text__);
      }

      el.appendChild(__el_mask__);
      el.mask = __el_mask__;

      // 监听binding.value，实现动态控制loading的显示隐藏
      if (binding.value) {
        __el_mask__.style.display = 'flex';
      }

    });
  },
  update (el, binding) {
    Vue.nextTick(() => {
      if (el.mask) {
        if (binding.value) {
          el.mask.style.display = 'flex';
        } else {
          el.mask.style.display = 'none';
        }
      }
    });
  },
  unbind(el) {
    el.mask && el.removeChild(el.mask);
  }

};
